import React from 'react';
import { FormGroup } from 'reactstrap';

const withFormGroup = Group => props => (
  <FormGroup>
    <Group {...props} />
  </FormGroup>
);

export default withFormGroup;


// WEBPACK FOOTER //
// ./src/components/hocs/withFormGroup.jsx